import React from 'react';
import '../styles/Home.css';

function Home(props) {
    return (
        <div>
           <div className="home">
            <div className="about">
                <h2>Hi, My name is Deepu</h2>
                <div className='prompt'>
                   <p> A software developer with a hardcore passion for learning and creating.</p>
                </div>
            </div>
           </div>
           <div className="skills">
            <h1>Skills</h1>
            <ol className="list">
                <li className="item">
                    <h2>Front-End</h2>
                    <span >ReactJS, Redux, HTML, CSS, React-Native, npm, BootStrap, TailwindCSS</span>
                </li>
                <li className="item">
                    <h2>Back-End</h2>
                    <span >NodeJS ExpressJS MongoDB SQL</span>
                </li>
                <li className="item">
                    <h2>Languages</h2>
                    <span >JavaScript, C++</span>
                </li>
            </ol>

           </div>
        </div>
    );
}

export default Home;